import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for invoices hooks
 * Keys match backend controller method names
 */
export const invoicesKeys = {
  findAll: (params?: QueryParamsDto) =>
    ["invoices", "findAll", params] as const,
  findOne: (id: string) => ["invoices", "findOne", id] as const,
} as const
